import { URL_REGEX_PATTERN } from '@app/constant/RegexConstant'
import { Translation } from 'react-i18next'
import * as Yup from 'yup'

const validateValue = {
  price: {
    min: 0,
    max: 999999999999,
  },

  quantity: {
    min: 1,
  },

  pos: {
    min: 1,
  },

  categories: {
    min: 1,
  },

  images: {
    min: 1,
  },

  info_link: {
    max: 255,
  },
  limit_min: {
    min: 1,
  },
}

export const voucherSchema = Yup.object().shape(
  {
    name: Yup.string()
      .max(255)
      .trim()
      .required(<Translation>{(t) => t('VALIDATE.REQUIRED_NAME')}</Translation>),

    info_link: Yup.string()
      .nullable()
      .notRequired()
      .when('info_link', {
        is: (value) => value?.length,
        then: (rule) =>
          rule.matches(URL_REGEX_PATTERN, {
            message: <Translation>{(t) => t('VALIDATE.HOME_PAGE_LINK')}</Translation>,
          }),
      }),

    merchant: Yup.object().nullable(),

    expired_date: Yup.date().required(<Translation>{(t) => t('VALIDATE.REQUIRED_EXPIRED')}</Translation>),

    categories: Yup.array().required(<Translation>{(t) => t('VALIDATE.REQUIRED_CATEGORY')}</Translation>),

    images: Yup.array()
      .required(<Translation>{(t) => t('VALIDATE.REQUIRED_SLIDER')}</Translation>)
      .min(
        validateValue.images.min,
        <Translation>{(t) => t('VALIDATE.VALIDATE_SLIDER', { number: validateValue.images.min })}</Translation>
      ),

    pos: Yup.array()
      .required(<Translation>{(t) => t('VALIDATE.REQUIRED_POS')}</Translation>)
      .min(
        validateValue.pos.min,
        <Translation>{(t) => t('VALIDATE.VALID_POS', { number: validateValue.pos.min })}</Translation>
      ),

    price: Yup.number()
      .required(<Translation>{(t) => t('VALIDATE.REQUIRED_PRICE')}</Translation>)
      .integer(<Translation>{(t) => t('VALIDATE.INTEGER_PRICE')}</Translation>)
      .min(
        validateValue.price.min,
        <Translation>{(t) => t('VALIDATE.VALID_MIN_PRICE', { number: validateValue.price.min })}</Translation>
      )
      .max(
        validateValue.price.max,
        <Translation>{(t) => t('VALIDATE.VALID_MAX_PRICE', { number: validateValue.price.max })}</Translation>
      )
      .transform((value) => (isNaN(value) ? undefined : value)),

    quantity: Yup.number()
      .required(<Translation>{(t) => t('VALIDATE.REQUIRED_QUANTITY')}</Translation>)
      .integer(<Translation>{(t) => t('VALIDATE.INTEGER_QUANTITY')}</Translation>)
      .min(
        validateValue.quantity.min,
        <Translation>{(t) => t('VALIDATE.VALID_MIN_QUANTITY', { number: validateValue.quantity.min })}</Translation>
      )
      .transform((value) => (isNaN(value) ? undefined : value)),

    limit_max: Yup.number()
      .when('limit_min', (limit_min, schema) =>
        schema.min(limit_min, <Translation>{(t) => t('VALIDATE.VALID_MAX_VOUCHER')}</Translation>)
      )
      .when('quantity', (quantity, schema) =>
        schema.max(quantity, <Translation>{(t) => t('VALIDATE.VALID_MAX_VOUCHER_WITH_QUANTITY')}</Translation>)
      )
      .nullable()
      .transform((value) => (isNaN(value) ? undefined : value)),

    limit_min: Yup.number()
      .integer(<Translation>{(t) => t('VALIDATE.VALID_NUMBER_INT')}</Translation>)
      .nullable()
      .transform((value) => (isNaN(value) ? undefined : value))
      .min(
        validateValue.limit_min.min,
        <Translation>{(t) => t('VALIDATE.VALID_MIN_QUANTITY', { number: validateValue.limit_min.min })}</Translation>
      )
      .when('quantity', (quantity, schema) =>
        schema.max(quantity, <Translation>{(t) => t('VALIDATE.VALID_MAX_VOUCHER_WITH_QUANTITY')}</Translation>)
      ),
  },
  [['info_link', 'info_link']]
)
